module.exports = __webpack_public_path__ + "media/images/project/menu-804538285e07c210c4472bacf30b6245.svg";